import React from "react";
import { useTranslation } from "react-i18next";

import { FilterMenu } from "@common/filterMenu";
import { Props } from "./types";
import { DataTypeFilter } from "./dataTypeFilter";
import styles from "./styles.scss";

function Filters({ filter, project, setFilter }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.filters}>
      <div className={styles.section}>
        <p className={styles.label}>
          {t("exportReportsPage.wbsZonesReport.filters.seeTasksOf")} :
        </p>
        <FilterMenu
          filter={filter}
          placeholder={t(
            "exportReportsPage.wbsZonesReport.filters.allResources",
          )}
          views={[
            "resources",
            "groups",
            "resourceTags",
            "projectsElementsTags",
          ]}
          openedViews={["resources"]}
          setFilter={setFilter}
        />
      </div>
      <div className={styles.section}>
        <DataTypeFilter
          selectedDataTypes={filter.dataTypes || []}
          selectDataType={(dataType) =>
            setFilter({
              ...filter,
              dataTypes: [...(filter.dataTypes || []), dataType],
            })
          }
          unSelectDataType={(dataType) =>
            setFilter({
              ...filter,
              dataTypes: (filter.dataTypes || []).filter(
                (type) => type !== dataType,
              ),
            })
          }
        />
      </div>
      <div>
        <button
          className={styles.resetButton}
          onClick={() =>
            setFilter({
              resources: [],
              dataTypes: [],
              projects: [project],
            })
          }
        >
          {t("exportReportsPage.wbsZonesReport.filters.resetFilters")}
        </button>
      </div>
    </div>
  );
}

export { Filters };
